import React, { useState } from "react";
import PostHeader from "../../Components/PostHeader";
import PostContent from "../../Components/PostContent";
import PostActions from "../../Components/PostActions";
import CommentSection from "../../Components/CommentSection";
import axios from "axios";
import Cookies from "js-cookie";
import BaseUrl from "../../Components/BaseUrl";

const LinkedInPost = ({
  postData,
  groupData,
  currentUser,
  isExpanded,
  onToggleExpand,
}) => {
  const [post, setPost] = useState(postData);
  const [showComments, setShowComments] = useState(false);

  const handleLike = async (e) => {
    e.preventDefault();
    const newIsLiked = !post.has_liked;
    const newLikeCount = newIsLiked ? post.likes + 1 : post.likes - 1;

    setPost((prev) => ({
      ...prev,
      has_liked: newIsLiked,
      likes: newLikeCount,
    }));
    try {
      if (post.has_liked) {
        await axios.post(
        
          `${BaseUrl}grouppostunlike/${groupData.id || postData.group_id}/${
            postData.id
          }`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
      } else {
        await axios.post(
          `${BaseUrl}grouppostlike/${groupData.id || postData.group_id}/${
            postData.id
          }`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
      }
    } catch (error) {
      console.log("Error toggling like:", error);
    }
  };

  // const handleAddComment = async (newComment) => {
  //   console.log(newComment);
  //   setPost((prev) => ({
  //     ...prev,
  //     comments: [newComment, ...prev.comments],
  //   }));

  //   try {
  //     const formData = new FormData();
  //     formData.append("comment", newComment.comment);

  //     const response = await axios.post(
  //       BaseUrl + `groupComment/${groupData.id||postData.group_id}/${postData.id}`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${Cookies.get("token")}`,
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error submitting comment:", error);
  //   }
  // };
  const handleAddComment = async (newComment) => {
    setPost((prev) => ({
      ...prev,
      comments: [newComment, ...prev.comments],
    }));

    try {
      const formData = new FormData();
      formData.append("comment", newComment.comment);

      const groupId = groupData?.id || postData?.group_id;
      const postId = postData?.id;

      if (!groupId || !postId) {
        console.error("Missing groupId or postId");
        return;
      }

      const response = await axios.post(
        `${BaseUrl}groupComment/${groupId}/${postId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleCommentLike = async (commentId, isLiked) => {
    setPost((prev) => ({
      ...prev,
      comments: prev.comments.map((comment) => {
        if (comment.comment_id === commentId) {
          return {
            ...comment,
            has_liked_comment: !isLiked,
            comment_likes: isLiked
              ? comment.comment_likes - 1
              : comment.comment_likes + 1,
          };
        }

        if (comment.replies && comment.replies.length > 0) {
          const updatedReplies = comment.replies.map((reply) => {
            if (reply.comment_id === commentId) {
              return {
                ...reply,
                has_liked_comment: !isLiked,
                comment_likes: isLiked
                  ? reply.comment_likes - 1
                  : reply.comment_likes + 1,
              };
            }
            return reply;
          });
          return { ...comment, replies: updatedReplies };
        }

        return comment;
      }),
    }));

    try {
      const endpoint = isLiked
        ? `${BaseUrl}grouppostcommentunlike/${commentId}`
        : `${BaseUrl}grouppostcommentlike/${commentId}/${postData.id}/${
            groupData.id || postData.group_id
          }`;

      await axios.post(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      setPost((prev) => ({
        ...prev,
        comments: prev.comments.map((comment) => {
          if (comment.comment_id === commentId) {
            return {
              ...comment,
              has_liked_comment: isLiked, // revert back
              comment_likes: isLiked
                ? comment.comment_likes + 1
                : comment.comment_likes - 1,
            };
          }

          if (comment.replies && comment.replies.length > 0) {
            const revertedReplies = comment.replies.map((reply) => {
              if (reply.comment_id === commentId) {
                return {
                  ...reply,
                  has_liked_comment: isLiked,
                  comment_likes: isLiked
                    ? reply.comment_likes + 1
                    : reply.comment_likes - 1,
                };
              }
              return reply;
            });
            return { ...comment, replies: revertedReplies };
          }

          return comment;
        }),
      }));
    }
  };

  const handleAddReply = async (parentCommentId, newReply) => {
    console.log(newReply);
    setPost((prev) => ({
      ...prev,
      comments: prev.comments.map((comment) => {
        if (comment.comment_id === parentCommentId) {
          return {
            ...comment,
            replies: comment.replies
              ? [...comment.replies, newReply]
              : [newReply],
          };
        }
        return comment;
      }),
    }));
    console.lo;
    try {
      const formData = new FormData();
      formData.append("comment", newReply.comment);

      const response = await axios.post(
        `${BaseUrl}groupComment/${groupData.id || postData.group_id}/${
          postData.id
        }/${parentCommentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const toggleComments = () => {
    setShowComments(!showComments);
  };

  return (
    <div className="bg-white rounded-lg shadow ">
      <PostHeader post={post} groupData={groupData} />
      <PostContent
        content={post.content}
        media={post.media}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
      />

      <div className="px-4 py-2 text-sm text-gray-500 border-b flex items-center justify-between">
        <span>
          {post.likes} {post.likes === 1 ? "like" : "likes"}
        </span>
        <span>
          {post.comments.length}{" "}
          {post.comments.length === 1 ? "comment" : "comments"}
        </span>
      </div>

      <PostActions
        isLiked={post.has_liked}
        onLike={handleLike}
        onComment={toggleComments}
      />

      {showComments && (
        <CommentSection
          comments={post.comments}
          currentUser={currentUser}
          onAddComment={handleAddComment}
          onCommentLike={handleCommentLike}
          onAddReply={handleAddReply}
          postId={post.id}
          onClose={() => setShowComments(false)}
        />
      )}
    </div>
  );
};

export default LinkedInPost;
